import { PARALLEL_LOOP_BLOCKER_CODES } from '@shared/workflow/getParallelLoopBlockers.js';

const LABELS = {
  [PARALLEL_LOOP_BLOCKER_CODES.BREAK_STEP]: 'uses Break, which stops the whole loop',
  [PARALLEL_LOOP_BLOCKER_CODES.FLOW_CONTROL_STOPS_LOOP]: 'uses a Flow Control action that stops the loop or the workflow',
  [PARALLEL_LOOP_BLOCKER_CODES.FLOW_CONTROL_OPTION_BREAKS]: 'is set to break the loop on failure or on no results',
  [PARALLEL_LOOP_BLOCKER_CODES.MEMORY_WRITE]: 'writes workflow memory, which items would overwrite in a random order',
  [PARALLEL_LOOP_BLOCKER_CODES.KEY_VALUE_READ_WRITE]: 'reads and writes Key-Value Storage, so items could lose each other’s updates',
  [PARALLEL_LOOP_BLOCKER_CODES.KEY_VALUE_UNVERIFIED]: 'uses Key-Value Storage and its action could not be checked',
  [PARALLEL_LOOP_BLOCKER_CODES.WEBHOOK_RESPONSE]: 'sends the webhook response, which can only happen once',
  [PARALLEL_LOOP_BLOCKER_CODES.PAGINATION_ENDS_WORKFLOW]: 'ends the workflow when its page limit is reached, which stops the whole loop',
  [PARALLEL_LOOP_BLOCKER_CODES.CARRIED_REFERENCE]: 'reads a value from the previous item',
  [PARALLEL_LOOP_BLOCKER_CODES.INNER_LOOP_REFERENCE]: 'reads a step inside an inner loop, which keeps the previous item’s value when that loop has no items',
  [PARALLEL_LOOP_BLOCKER_CODES.FUNCTION_UNSAFE]: 'calls a function that writes shared state or could not be loaded'
};

/**
 * One sentence per blocker for the Parallel Processing slider and feature box.
 */
const getParallelLoopBlockerLabel = ({ blocker, steps = [] }) => {
  const step = steps.find((candidate) => candidate?.id === blocker?.stepId);
  const stepName = step?.message || step?.name || step?.appSlug || blocker?.stepId;
  const stepNumber = Number.isInteger(step?.stepNumber) ? `Step ${step.stepNumber}` : null;
  const subject = stepNumber ? `${stepNumber} (${stepName})` : stepName;
  return `${subject} ${LABELS[blocker?.code] || 'cannot run in parallel'}.`;
};

export default getParallelLoopBlockerLabel;
